export const categories = [
  {
    slug: "tutorial",
    name: "使用教程",
    description: "从零开始掌握磁力金牛，手把手教你每一步操作，轻松上手财富工具",
    icon: "ri-book-open-line",
    color: "accent",
  },
  {
    slug: "strategy",
    name: "收益策略",
    description: "深度解析磁力金牛核心收益逻辑，助你制定最优资产增值方案",
    icon: "ri-line-chart-line",
    color: "primary",
  },
  {
    slug: "method",
    name: "吸金方法",
    description: "揭秘磁力金牛独特吸金机制，掌握高效财富积累的独家秘诀",
    icon: "ri-money-dollar-circle-line",
    color: "accent",
  },
  {
    slug: "cases",
    name: "成功案例",
    description: "真实用户见证，看他们如何借助磁力金牛实现财富跨越式增长",
    icon: "ri-trophy-line",
    color: "primary",
  },
  {
    slug: "register",
    name: "注册流程",
    description: "快速入门指南，三分钟完成注册，即刻开启你的财富增长之旅",
    icon: "ri-user-add-line",
    color: "accent",
  },
];